import { CommonModule, NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './button.component.html',
  styleUrl: './button.component.css',
})
export class ButtonComponent {
  @Input() label?: string = '';
  @Input() customClasses: string | string[] = '';
  @Input() type: 'button' | 'submit' = 'button';
  @Input() icon?: string = '';
  @Input() iconPosition?: 'start' | 'end' = 'start';
  @Input() disabled?: boolean = false;
  @Input() link?: string;
}
